import React, { useLayoutEffect } from "react";
import s from "./TabComponent.module.less";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import clsx from "clsx";

export interface TabIProps {
  id: string;
  label: string;
  permission: string;
}

export interface TabsIProps {
  tabs: TabIProps[];
  horizontal?: "start" | "end" | "center" | "between";
  vertical?: "start" | "end" | "center";
  fontSize?: "14" | "16" | "18";
}

const TabComponent: React.FC<TabsIProps> = ({
  tabs,
  horizontal,
  vertical,
  fontSize = "14",
}) => {
  const setData = useSetLocationData();
  const { selected } = useGetLocationData();

  useLayoutEffect(() => {
    if (!selected) setData("selected", tabs[0].id);
  }, []);

  const handleTabElement = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    setData("selected", target.dataset.value ?? tabs[0].id);
  };

  return (
    <div
      className={clsx(
        s.tabContainer,
        horizontal ? `${s[horizontal]}` : s.between
      )}
      onClick={handleTabElement}
    >
      {tabs.map((tab) => (
        <div
          data-value={tab.id}
          data-size={fontSize}
          key={tab.id}
          className={`${s.tab} ${selected === tab.id ? s.active : ""} ${
            vertical ? s[vertical + "V"] : s.startV
          }`}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default TabComponent;
